import React from 'react';
import InputMask from 'react-input-mask';

interface PhoneComponentProps {
  [key: string]: any;
}

const PhoneComponent: React.FC<PhoneComponentProps> = (props) => {
  return <InputMask {...props} mask='+971999999999' maskChar='' />;
};

export const genericPhone: React.FC<PhoneComponentProps> = (props) => {
  return <InputMask {...props} mask='+9999999999999999' maskChar='' />;
};

export default PhoneComponent;
